import { z } from "zod";
import { AccountUserSchema } from "./AccountUser";
import { BaseChangelogSchema } from "./Changelog";

export const DocumentOfferQuestionChangelogSchema = BaseChangelogSchema.extend({
  accountUser: AccountUserSchema.nullable(),
});
export const PartialDocumentOfferQuestionChangelogSchema =
  DocumentOfferQuestionChangelogSchema.deepPartial();

export type PartialDocumentOfferQuestionChangelog = z.infer<
  typeof PartialDocumentOfferQuestionChangelogSchema
>;

export type DocumentOfferQuestionChangelog = z.infer<
  typeof DocumentOfferQuestionChangelogSchema
>;
